import { PaymentBankIcon, PaymentCardIcon, PaymentPlanIcon } from "../Icons/Icons";
import React from "react";

const PaymentCounts = ({ count }) => {

  return (
    <div className="flex py-4 mx-5 rounded-2xl border border-divider">
      <div className="flex gap-4 border-r-2 border-dashed border-divider items-center   px-10">
        <PaymentCardIcon bgFill="var(--color-info-background)" fill="var(--color-info-main)" />
        <div className="flex flex-col pl-5">
          <span className="font-bold text-lg-18 mb-1">
            {count?.card ?? '0'}
          </span>
          <span className="text-[14px]">Card</span>
        </div>
      </div>

      <div className="flex px-10 gap-4 items-center">
        <PaymentBankIcon bgFill="var(--color-success-background)" fill="var(--color-success-main)" />
        <div className="flex flex-col">
          <span className="font-bold text-lg-18 mb-1">
            {count?.bank ?? '0'}
          </span>
          <span className="text-[14px]">Bank account</span>
        </div>
      </div>
    </div>
  )
}

export default PaymentCounts
